import { render, staticRenderFns } from "./mobileSealBorrow.vue?vue&type=template&id=816cbbc6&scoped=true&"
import script from "./mobileSealBorrow.vue?vue&type=script&lang=js&"
export * from "./mobileSealBorrow.vue?vue&type=script&lang=js&"
import style0 from "./mobileSealBorrow.vue?vue&type=style&index=0&id=816cbbc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816cbbc6",
  null
  
)

export default component.exports